module.exports = __webpack_public_path__ + "static/media/link.d3d602a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/link.svg
// module id = 482
// module chunks = 0